import { Link } from 'react-router-dom'
import { Edit } from 'lucide-react'
import FavoriteStar from '../Favorites/FavoriteStar'
import Avatar from '../UI/Avatar'
import { getTalentTypeHexColor, getTalentTypeIcon, getTalentTypeLabel } from '../../utils/talentTypeUtils'

const StatusBadge = ({ label, value, color }) => (
  <span
    className="inline-flex min-w-0 items-center gap-1 rounded-md px-2 py-0.5 text-[11px] font-semibold text-white"
    style={{ backgroundColor: color || '#6b7280' }}
  >
    <span className="shrink-0 text-[9px] font-medium uppercase tracking-wide text-white/70">{label}</span>
    <span className="truncate">{value || 'Not defined'}</span>
  </span>
)

const MobileTalentStickyContext = ({ talent, canEdit }) => {
  const TypeIcon = getTalentTypeIcon(talent.talent_type)
  const displayName = [talent.last_name, talent.first_name].filter(Boolean).join(' ') || talent.authUser?.name || 'Talent'

  return (
    <div className="border-b border-light-border-primary bg-light-bg-primary px-3 py-2 shadow-sm dark:border-dark-border-primary dark:bg-dark-bg-secondary">
      <div className="flex min-w-0 items-center gap-2">
        <Avatar
          avatar={talent.authUser?.avatar}
          name={talent.authUser?.name || displayName}
          email={talent.authUser?.email}
          sizeClasses="h-9 w-9"
          iconSizeClasses="h-4 w-4"
          icon={TypeIcon}
          showInitialOnMissing={false}
          iconBgClassName="bg-light-bg-secondary dark:bg-dark-bg-tertiary"
          iconClassName="text-primary-600 dark:text-primary-400"
        />

        <div className="min-w-0 flex-1">
          <div className="truncate text-sm font-bold text-light-text-primary dark:text-dark-text-primary">{displayName}</div>
          <div className="mt-0.5 flex min-w-0 items-center gap-1.5 text-[10px] text-light-text-tertiary dark:text-dark-text-tertiary">
            <span className="truncate font-mono">ID {talent.id}</span>
            {talent.talent_id && <span className="truncate font-mono">Talent {talent.talent_id}</span>}
          </div>
        </div>

        <div className="flex shrink-0 items-center gap-1">
          <FavoriteStar
            talentId={talent.id}
            withDropdown={false}
            className="[&_button]:inline-flex [&_button]:h-10 [&_button]:w-10 [&_button]:items-center [&_button]:justify-center"
          />
          {canEdit && (
            <Link
              to={`/talents/${talent.id}/edit`}
              className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-primary-600 text-white transition-colors hover:bg-primary-700 dark:bg-primary-500 dark:hover:bg-primary-600"
              aria-label="Edit talent"
              title="Edit talent"
            >
              <Edit className="h-4 w-4" aria-hidden="true" />
            </Link>
          )}
        </div>
      </div>

      <div className="mt-1.5 flex min-w-0 items-center gap-1 overflow-hidden">
        <span
          className="inline-flex shrink-0 items-center gap-1 rounded-md px-2 py-0.5 text-[11px] font-semibold text-white"
          style={{ backgroundColor: getTalentTypeHexColor(talent.talent_type) }}
        >
          <TypeIcon className="h-3 w-3" aria-hidden="true" />
          {getTalentTypeLabel(talent.talent_type)}
        </span>
        <StatusBadge label="Status" value={talent.currentStatus?.name} color={talent.currentStatus?.color} />
        <StatusBadge label="Stage" value={talent.currentStage?.name} color={talent.currentStage?.color} />
      </div>
    </div>
  )
}

export default MobileTalentStickyContext
